import { render, staticRenderFns } from "./ShadowBoxTitleDescription.vue?vue&type=template&id=5d579e1b&scoped=true&"
import script from "./ShadowBoxTitleDescription.vue?vue&type=script&lang=js&"
export * from "./ShadowBoxTitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./ShadowBoxTitleDescription.vue?vue&type=style&index=0&id=5d579e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d579e1b",
  null
  
)

export default component.exports